import { Platform } from 'react-native';

export function hideDocumentSplash() {
  if (Platform.OS !== 'web' || typeof document === 'undefined') {
    return;
  }
  document.getElementById('app-splash')?.remove();
}

export async function waitForDocumentFonts() {
  if (Platform.OS !== 'web' || typeof document === 'undefined' || !document.fonts?.ready) {
    return;
  }
  await Promise.race([
    document.fonts.ready,
    new Promise<void>(resolve => setTimeout(resolve, 1200)),
  ]);
}
